// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Admin-clientGrid-___clientGrid__container___1gRYp","title-box":"src-components-Admin-clientGrid-___clientGrid__title-box___2SetL","search-box":"src-components-Admin-clientGrid-___clientGrid__search-box___24YSK","title":"src-components-Admin-clientGrid-___clientGrid__title___3cMuW","button-box":"src-components-Admin-clientGrid-___clientGrid__button-box___3NuY9","client-box":"src-components-Admin-clientGrid-___clientGrid__client-box___1rTe4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/clientGrid/clientGrid.css
// module id = 1052
// module chunks = 0